import 'antd/dist/antd.css';
import {Menu, Breadcrumb} from 'antd';
import {Link, Redirect, useHistory} from 'react-router-dom';
import {
    HomeOutlined,
    CalendarOutlined,
    SettingOutlined,
    TeamOutlined,
    UserOutlined,
    LogoutOutlined,
    MedicineBoxOutlined
} from '@ant-design/icons';
import {useEffect, useState} from 'react';
import {getToken, getUser, removeUserSession} from "../../Utils/common";


const {SubMenu} = Menu;

function MyMenu(props) {

    //const [active, setActive] = useState(props.active);
    const history = useHistory()
    const {active} = props.active
    const [isProfessional, setIsProfessional] = useState(() => {
        const user = getUser()
        let _is_profesional = false
        for (const group in user.groups) {
            console.log(user.groups[group])
            if (user.groups[group] == "profesional") {
                console.log("Is a professional")
                _is_profesional = true
            }
        }
        return _is_profesional
    })
    //useEffect( () => {;}, [active])

    const handleClick = (menu) => {
        console.log(menu);
    }

    useEffect(() => {
        const token = getToken();
        if (!token) {
            console.log("No hay token");
        }
    })


    console.log(isProfessional)
    if (isProfessional) {
        return (
            <>
                <Menu theme="dark" onClick={handleClick} selectedKeys={[active]} mode="inline">
                    <Menu.Item key="1" icon={<CalendarOutlined/>}>
                        <Link to="/professional_appointments/">Agenda </Link>
                    </Menu.Item>
                    <Menu.Item key="2" icon={<MedicineBoxOutlined/>}>
                        <Link to="/hospitalizations/">Internaciones</Link>
                    </Menu.Item>
                    <Menu.Item key="7" icon={<MedicineBoxOutlined/>}>
                        <Link to="/medications/">Medicamentos</Link>
                    </Menu.Item>
                    <Menu.Item key="8" icon={<MedicineBoxOutlined/>}>
                        <Link to="/hospitalization-clinical-histories/">HC Internación</Link>
                    </Menu.Item>
                    <Menu.Item key="5" icon={<LogoutOutlined />}>
                        <Link to="/" onClick={() => {
                            removeUserSession()
                            history.push("/login")
                        }}>Salir</Link>
                    </Menu.Item>
                </Menu>
            </>
        )
    } else {
        return (
            <>
                <Menu theme="dark" onClick={handleClick} selectedKeys={[active]} mode="inline">
                    <Menu.Item key="1" icon={<HomeOutlined/>}>
                        <Link to="/">Home</Link>
                    </Menu.Item>
                    <Menu.Item key="2" icon={<CalendarOutlined/>}>
                        <Link to="/appointments/">Agenda </Link>
                    </Menu.Item>
                    <SubMenu key="su" icon={<SettingOutlined/>} title="Residentes">
                        <Menu.Item key="su1" icon={<UserOutlined/>}>
                            <Link to="/pacients/">Administrar</Link>
                        </Menu.Item>
                        <Menu.Item key="su2" icon={<UserOutlined/>}>
                            <Link to="/pacientsfrequency/">Depurados</Link>
                        </Menu.Item>
                    </SubMenu>

                    <Menu.Item key="3" icon={<TeamOutlined/>}>
                        <Link to="/profesionals/">Profesionales</Link>
                    </Menu.Item>
                    <SubMenu key="4" icon={<TeamOutlined/>} title="Facturación">
                        <Menu.Item key="4-1">
                            <Link to="/billing/">Reporte Profesionales</Link>
                        </Menu.Item>
                        <Menu.Item key="4-2">
                            <Link to="/billing/medications/">Reporte Medicamentos</Link>
                        </Menu.Item>
                    </SubMenu>
                    <Menu.Item key="6" icon={<MedicineBoxOutlined/>}>
                        <Link to="/hospitalizations/">Internaciones</Link>
                    </Menu.Item>
                    <Menu.Item key="7" icon={<MedicineBoxOutlined/>}>
                        <Link to="/medications/">Medicamentos</Link>
                    </Menu.Item>
                    <Menu.Item key="8" icon={<MedicineBoxOutlined/>}>
                        <Link to="/hospitalization-clinical-histories/">HC Internación</Link>
                    </Menu.Item>
                    <Menu.Item key="5" icon={<LogoutOutlined />}>
                        <Link to="/" onClick={() => {
                            removeUserSession()
                            history.push("/login")
                        }}>Salir</Link>
                    </Menu.Item>
                    {/*<SubMenu key="sub1" icon={<SettingOutlined />} title="Configuracion">
                    <Menu.Item key="3">
                    <Link to="/users/">Usuarios</Link>
                    </Menu.Item>
                </SubMenu>*/}
                </Menu>
            </>
        )
    }
}

export default MyMenu;
